import {BaseService} from "@/core/services/BaseService";

class ESignTemplateService extends BaseService<any> {
  endpoint = "/esign-template"


  async getFields() {
    return this.http().get(`${this.endpoint}/entity-fields`).then(res => {
      return res.data
    })
  }
}

export default new ESignTemplateService();